<template>
  <div class="page-common-prompt-message">
    <layout :title="title"
            :content="content"
            :show-recommend="contact != null"
            hint="推荐你添加学习顾问微信"
    >
      <div class="qr-code-container">
        <div class="qr-code-hint">{{ contact.qrCode.hint }}</div>
        <ym-qr-code :src="contact.qrCode.src" />
      </div>
      <div class="contact-tel" v-html="telString"></div>
      <template #bottom>
        <div class="recommend-product"
             v-if="products.length > 0"
        >
          <div class="block-title">推荐课程</div>
          <product-list :list="products"
          />
        </div>
      </template>
    </layout>
  </div>
</template>

<script>
  import Layout from '@/pages/Common/components/OrderRecommendLayout';
  import ProductList from '@/components/ProductList/List';
  import QrCode from '@/components/QrCode';

  export default {
    name: 'OrderRecommendContact',
    components: {
      Layout,
      ProductList,
      'ym-qr-code': QrCode,
    },
    props: {
      title: {
        type: String,
        required: true,
      },
      content: {
        type: String,
        required: true,
      },
      contact: {
        type: Object,
      },
      products: {
        type: Array,
      },
    },
    computed: {
      telString() {
        const { contact } = this;
        const { tel } = contact;
        return tel.hint.replace('%tel%', `<a class="link" href="tel:${tel.number}">${tel.number}</a>`);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .qr-code-container {
    margin-top: @size-base;
  }

  .qr-code-hint {
    font-size: @font-size-small;
    color: @color-text-lighter;
    margin-bottom: @size-small;
  }

  .contact-tel {
    line-height: 1;
    margin-top: @size-base;
    font-size: @font-size-base;
    color: @color-text-lighter;
  }

  .recommend-product {
    background-color: @color-white;
    .block-title {
      padding: @size-base @size-base 0 @size-base;
    }
  }
</style>
